import {Button, message, Progress, Space} from "antd";
import {
  StyledPortfolioImagesItemListWrapper,
  StyledPortfolioImagesWrapper,
} from "./styles";
import {
  StoreServicePortfolioImagesUploadFileOptions,
  StoreServicePortfolioImagesUploadProps,
  OfferingPortfolioImagesUploadStatus,
} from "./types";
import {StoreServicePortfolioImagesItem} from "./porfolio-images-item";
import {useRef, useState} from "react";
import {PlusCircleFilled} from "@ant-design/icons";
import axios from "axios";
import {API_BASE_URL, API_BASE_URL_V2} from "../../../../services/config";

export const uploadStoreServicePortfolioImage = async ({
  formData,
  onProgress,
  cancelToken,
  authToken,
}: StoreServicePortfolioImagesUploadFileOptions) => {
  return axios.post(
    `${API_BASE_URL_V2}uploads/product-service/portfolio-image`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      onUploadProgress: (event) => {
        if (event.total) {
          const percent = Math.round((event.loaded * 100) / event.total);
          onProgress?.(percent);
        }
      },
      cancelToken,
    }
  );
};

export function StoreServicePortfolioImagesUpload({
  defaultPortfolioImages,
  productServiceId,
  isDeleteLoading,
  isUploadLoading,
  deletePortfolioImage,
  uploadPortfolioImages,
}: StoreServicePortfolioImagesUploadProps) {
  const MAX_FILES = 5;
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] =
    useState<OfferingPortfolioImagesUploadStatus>("pending");
  const fileInputRef = useRef<HTMLInputElement>(null);

  // console.log({progress, uploading});

  function handleContentUploadButtonClick() {
    fileInputRef.current?.click();
  }
  return (
    <div>
      <Space direction="vertical" size={16} style={{display: "flex"}}>
        <p>
          Add image samples to showcase your work and help customers understand what to
          expect
        </p>
        <StyledPortfolioImagesWrapper>
          {defaultPortfolioImages.length > 0 && (
            <StyledPortfolioImagesItemListWrapper>
              <Space size={8} direction="vertical" style={{display: "flex"}}>
                {defaultPortfolioImages.map((pi) => (
                  <StoreServicePortfolioImagesItem
                    key={pi.id}
                    deleteFunction={() =>
                      deletePortfolioImage({
                        mediaId: pi.id,
                        productServiceId: pi.entityId,
                      })
                    }
                    imgSrc={pi.mediaUrl}
                    isDeleteLoading={isDeleteLoading}
                    uploadStatus={uploading}
                  />
                ))}
              </Space>
            </StyledPortfolioImagesItemListWrapper>
          )}
          <div>
            {uploading !== "pending" && (
              <Progress
                percent={progress}
                status={
                  uploading === "error"
                    ? "exception"
                    : uploading === "uploading"
                    ? "active"
                    : uploading === "success"
                    ? "success"
                    : uploading === "cancelled"
                    ? "exception"
                    : "normal"
                }
                strokeColor={uploading === "success" ? "#52c41a" : "#222222"}
                // showInfo={false}
                // success={{strokeColor: "#52c41a", percent: 100}}
              />
            )}
          </div>

          <div>
            <input
              style={{display: "none"}}
              ref={fileInputRef}
              type="file"
              multiple
              accept="image/jpeg,image/jpg,image/png,image/webp"
              onChange={(e) => {
                if (e.target.files) {
                  const files = Array.from(e.target.files);
                  const filesSelected = e.target.files;

                  // Filter only image files
                  const imageFiles = files.filter((file) =>
                    file.type.startsWith("image/")
                  );

                  if (imageFiles.length === 0) {
                    message.info("Please select image files only");
                    return;
                  }

                  // Check if adding these files would exceed the limit
                  if (defaultPortfolioImages.length + imageFiles.length > MAX_FILES) {
                    message.info(
                      `You can only select up to ${MAX_FILES} images. Currently selected: ${
                        defaultPortfolioImages.length + imageFiles.length
                      }`
                    );
                    return;
                  }
                  if (filesSelected && filesSelected.length > 0) {
                    if (productServiceId) {
                      const formData = new FormData();
                      Array.from(filesSelected).forEach((file) => {
                        formData.append("portfolio-image", file);
                      });
                      formData.append("productServiceId", `${productServiceId}`);
                      setUploading("uploading");
                      setProgress(0);
                      uploadPortfolioImages.mutate(
                        {
                          data: formData,
                          productServiceId,
                          onProgress: (progress: number) => {
                            setProgress(progress);
                          },
                        },
                        {
                          onSuccess: (data) => {
                            message.success(
                              `Uploaded ${filesSelected.length} file(s) successfully`
                            );
                            if (fileInputRef.current) {
                              fileInputRef.current.value = "";
                            }
                            setUploading("success");
                            setTimeout(() => {
                              setUploading("pending");
                            }, 3000);
                            // console.log({successDataCoverImages: data});
                          },
                          onError: () => {
                            setUploading("error");
                            setTimeout(() => {
                              setUploading("pending");
                            }, 3000);
                          },
                        }
                      );
                    }
                  } else {
                    return message.error("No files ");
                  }
                }
              }}
            />
            {defaultPortfolioImages.length < 5 && (
              <Space size={16} direction="vertical" style={{display: "flex"}}>
                <p style={{textAlign: "center"}}>
                  Images should be horizontal, at least 1280x720px
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    onClick={handleContentUploadButtonClick}
                    size="small"
                    icon={<PlusCircleFilled />}
                    disabled={isDeleteLoading}
                    loading={isUploadLoading}
                  >
                    Upload images
                  </Button>
                </div>
              </Space>
            )}
          </div>
        </StyledPortfolioImagesWrapper>
      </Space>
    </div>
  );
}
